import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { each } from 'async';
import { CSVLink } from 'react-csv';
const SummaryLineChart = ({
	metricField,
	metricData,
	channels,
	metricInitialVal,
	height,
}) => {
	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);
	const [metricFilter, setMetricFilter] = useState(metricInitialVal);

	const today = new Date();
	const csvDate = `${today.getFullYear()}_${
		today.getMonth() + 1
	}_${today.getDate()}`;

	useEffect(() => {
		if (metricData) {
			setCurrentData([metricData.lineData]);
		}
	}, [metricData]);

	// console.log('metricFilter', metricFilter);
	// console.log('metricData', metricData);
	// console.log('rowsData', rowsData);
	// console.log('channels', channels);
	// console.log('currentData', currentData);

	useEffect(() => {
		if (currentData && metricField && channels && channels[0]) {
			const channel = channels[0].value;
			if (metricFilter && !channel) {
				const tableLabels = [];
				const tableHeaders = [];
				let dates = [];
				const metricNames = [];
				currentData &&
					currentData.forEach((e, i) => {
						Object.values(e).forEach((each, idx) => {
							const name = Object.keys(e)[idx];
							dates = Object.values(e)[0] ? Object.values(e)[0][0].labels : [];

							each.forEach((eData) => {
								if (eData.label) {
									metricNames.push({ [name + ' ' + eData.label]: '' });

									const d = {
										label: eData.label + ' ' + name,
										field: eData.label + ' ' + name,
										data: eData.data,
										dates: dates,
									};
									const d2 = {
										label: eData.label + ' ' + name,
										field: eData.label + ' ' + name,
									};
									tableHeaders.push(d2);
									tableLabels.push(d);
								}
							});
						});
					});
				// console.log('tableLabels', tableLabels);
				// console.log('metricNames', metricNames);

				const headers = tableLabels && tableLabels.map((obj) => obj.label);

				const headersAndData = {};
				tableLabels &&
					tableLabels.forEach(
						({ label, data }) => (headersAndData[label] = data)
					);

				// console.log('headers', headers);
				// console.log('headersAndData', headersAndData);

				const format = dates.map((date, dIndex) => {
					let rowData = { date };
					// loop headers and assign value base on dIndex
					headers.forEach((h) => {
						// get current header value
						const value = headersAndData[h][dIndex];
						rowData[h] = value;
					});

					return rowData;
				});

				const addedRow = [
					{
						label: 'Dates',
						field: 'date',
					},
					...tableHeaders,
				];

				setRowsData({
					columns: addedRow,
					rows: format ? format : [],
				});
			}
		}
	}, [currentData, metricField, channels]);

	// console.log('rowsData', rowsData);

	return (
		<div>
			<h5 className='fw-bold text-mute'> Metric Table</h5>
			<div
				style={{
					height: height ? height : '370px',
					overflowY: 'scroll',
					overflowX: 'hidden',
				}}>
				<MDBDataTable
					data={rowsData}
					bordered
					noBottomColumns
					small
					responsive
					hover
					paging={false}
					searching={false}
				/>
			</div>

			{rowsData && rowsData.rows && (
				<div className='text-white'>
					<CSVLink
						className='badge rounded-pill bg-primary'
						data={rowsData.rows && rowsData.rows}
						// headers={rowsData.columns}
						filename={`dashboard${csvDate}.csv`}
						target='_blank'>
						Download as CSV
					</CSVLink>
				</div>
			)}
		</div>
	);
};

export default SummaryLineChart;
